/* Dynamic stock left script
 * Configuration via data attributes on element .dynamic-stock-left
 * data-stock-left: initial number
 * data-min: minimum floor (default 3)
 * data-max: maximum ceiling (default initial)
 * data-interval-min / data-interval-max: random seconds between decrements (default 25-60)
 * data-decrement-min / data-decrement-max: random decrement amount (default 1-2)
 * data-persist-key: localStorage key (default 'dyn_stock_left')
 * data-reset-hours: hours after which to reset (default 6)
 * --- Advanced phase control ---
 * data-slow-threshold: when current <= this value, enter slow phase
 * data-slow-interval-min / data-slow-interval-max: interval range in slow phase (fallback to normal if absent)
 * data-slow-decrement-min / data-slow-decrement-max: decrement range in slow phase (fallback to normal if absent)
 * data-skip-chance: 0-1 probability to skip a decrement cycle (default 0)
 */
(function() {
  function $(sel){return document.querySelector(sel);} 
  const el = $('.dynamic-stock-left');
  if(!el) return;
  const dataset = el.dataset;
  const initial = parseInt(dataset.stockLeft || '1000', 10);
  const min = parseInt(dataset.min || '3', 10);
  const max = parseInt(dataset.max || initial, 10);
  const intervalMin = parseInt(dataset.intervalMin || '2', 10); // seconds
  const intervalMax = parseInt(dataset.intervalMax || '10', 10); // seconds
  const decMin = parseInt(dataset.decrementMin || '1', 10);
  const decMax = parseInt(dataset.decrementMax || '2', 10);
  const persistKey = dataset.persistKey || 'dyn_stock_left';
  const resetHours = parseInt(dataset.resetHours || '6', 10);
  const resetAtMin = dataset.resetAtMin === 'true' || dataset.resetAtMin === '1';
  const resetRandomMin = parseInt(dataset.resetRandomMin || NaN, 10);
  const resetRandomMax = parseInt(dataset.resetRandomMax || NaN, 10);
  // Slow phase params
  const slowThreshold = parseInt(dataset.slowThreshold || '0', 10);
  const slowIntervalMin = parseInt(dataset.slowIntervalMin || intervalMin, 10);
  const slowIntervalMax = parseInt(dataset.slowIntervalMax || intervalMax, 10);
  const slowDecMin = parseInt(dataset.slowDecrementMin || decMin, 10);
  const slowDecMax = parseInt(dataset.slowDecrementMax || decMax, 10);
  const skipChance = parseFloat(dataset.skipChance || '0');

  // Load / reset logic
  let saved = null;
  try {
    const raw = localStorage.getItem(persistKey);
    if(raw){
      const obj = JSON.parse(raw);
      const ageH = (Date.now() - obj.ts) / 36e5;
      if(ageH < resetHours) {
        const savedVal = parseInt(obj.val, 10);
        // If saved below min (e.g., after raising min), treat as invalid and reset
        if(!isNaN(savedVal) && savedVal >= min) {
          saved = savedVal;
        } else {
          try { localStorage.removeItem(persistKey); } catch(_) {}
        }
      } else {
        localStorage.removeItem(persistKey);
      }
    }
  } catch(e) {}

  let current = Math.min(max, Math.max(min, saved != null ? saved : initial));
  el.textContent = current;

  function persist(){
    try { localStorage.setItem(persistKey, JSON.stringify({val: current, ts: Date.now()})); } catch(e) {}
  }

  function seedValue(){
    let seed = initial;
    if(!Number.isNaN(resetRandomMin) && !Number.isNaN(resetRandomMax) && resetRandomMax > resetRandomMin){
      seed = Math.floor(Math.random() * (resetRandomMax - resetRandomMin + 1)) + resetRandomMin;
    }
    seed = Math.min(max, Math.max(min + 1, seed)); // ensure above min
    return seed;
  }

  function scheduleNext(){
    if(current <= min){
      if(resetAtMin){
        current = seedValue();
        el.textContent = current;
        persist();
      } else {
        return; // stop at min if no reset requested
      }
    }
    const slowPhase = slowThreshold > 0 && current <= slowThreshold;
    const iMin = slowPhase ? slowIntervalMin : intervalMin;
    const iMax = slowPhase ? slowIntervalMax : intervalMax;
    const dMin = slowPhase ? slowDecMin : decMin;
    const dMax = slowPhase ? slowDecMax : decMax;
    const nextSec = Math.random() * (iMax - iMin) + iMin;
    setTimeout(() => {
      // Maybe skip this cycle
      if(skipChance > 0 && Math.random() < skipChance){
        scheduleNext();
        return;
      }
      const dec = Math.floor(Math.random() * (dMax - dMin + 1)) + dMin;
      const nextVal = current - dec;
      if(nextVal <= min && resetAtMin){
        current = seedValue();
      } else {
        current = Math.max(min, nextVal);
      }
      el.textContent = current;
      persist();
      scheduleNext();
    }, nextSec * 1000);
  }

  persist();
  scheduleNext();
})();
